export default __webpack_public_path__ + "static/media/Create Group  Step by step Wite.6c064dad.svg";